import React, { CSSProperties } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Ripple } from "@progress/kendo-react-ripple";

type fillMode = "solid" | "outline" | "flat" | "link";
type Type = "submit" | "button" | "reset";
type themeColor =
  | "primary"
  | "base"
  | "secondary"
  | "tertiary"
  | "info"
  | "success"
  | "warning"
  | "error"
  | "dark"
  | "light"
  | "inverse";

interface IButtonProps {
  id?: string;
  label: string;
  disabled?: boolean;
  color?: string;
  fillMode?: fillMode;
  type?: Type;
  width?: string;
  themeColor?: themeColor;
  className?: string;
  ref?: any;
  style?: CSSProperties;
  onClick?: () => void;
  // onFocus?: () => void;
}

const ButtonForAll: React.FC<IButtonProps> = ({
  label,
  id,
  disabled = false,
  fillMode = "solid",
  themeColor = "primary",
  type = "button",
  width = "fit-content",
  className = "",
  onClick,
  // onFocus,
  ref,
  style,
}) => {
  return (
    <Ripple>
      <Button
        id={id}
        ref={ref}
        type={type}
        fillMode={fillMode}
        style={{ width: width, ...style }}
        themeColor={themeColor}
        disabled={disabled}
        className={className}
        onClick={onClick}
        // onFocus={onFocus}
      >
        {label}
      </Button>
    </Ripple>
  );
};

export default ButtonForAll;
